import {useEffect, useMemo} from 'react';
import {ApiClientService} from '@dofleini/security';
import {API_SETTINGS} from '../constants/api.settings';
import {useQuery, useQueryClient} from 'react-query';
import {logout} from '../services/AuthClient';
import {USER_PROFILE} from '../constants/storage.variables';


export const useMe = () => {
  const queryClient = useQueryClient();
  const path = `${API_SETTINGS.auth}/users/me`;

  const user = useMemo(() => {
    const user = localStorage.getItem(USER_PROFILE);
    if (user)
      try {
        return JSON.parse(user);
      } catch (e) {
        //ignoring
      }
  }, []);

  const hasToken = !!ApiClientService.getToken();

  const {isLoading, error, data, refetch, isStale} = useQuery('user-me', async () => {
    if (!hasToken) return Promise.reject({authenticatedError: true});
    const {data} = await ApiClientService.get(path);
    localStorage.setItem(USER_PROFILE, JSON.stringify(data));
    return (data);

  }, {
    retry: 0, // Will retry failed requests 10 times before displaying an error
    refetchOnWindowFocus: false,
    enabled: hasToken
  });

  const status = error?.status;
  useEffect(() => {
    if (status === 401) {
      logout().then(() => {
        queryClient.invalidateQueries('user-me');
      });
    }
  }, [queryClient, status]);

  return {
    data: error?.status || error?.authenticatedError ? undefined : data || user,
    isLoading, error, refetch, isStale
  };
};

